import React from 'react';

import Typography from 'components-new/typography/typography';

import Banner from 'components-new/banner/banner';

import Icon from 'components-new/icon/icon';

import type { IconTypes } from 'components-new/icon';

interface PairTextPropTypes {
  title: string;
  value: string;
  className?: string;
  banner?: boolean;
  icon?: IconTypes;
}

const PairText: React.FC<PairTextPropTypes> = (props) => {
  const { title, value, className, banner, icon } = props;
  return (
    <div className={className}>
      <div className="flex flex-col justify-start items-start">
        <Typography
          variant="body-medium-bold"
          as="h5"
          className="text-gray-800 flex items-center justify-start"
        >
          {icon && <Icon icon={icon} className="mr-1" />}
          {title}
        </Typography>
        {banner && (
          <Banner title={value} variant="success" className="mt-3 px-2" />
        )}
        {!banner && (
          <Typography
            variant="body-large"
            as="h5"
            className="text-gray-700 mt-2"
          >
            {value}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PairText;
